/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoAllergiesChecked = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M24 22H13l5.5-11zm-6.1-1.65h1.2v-1.1h-1.2zm0-2.2h1.2v-2.2h-1.2z" />
        <path d="M12 2c5.523 0 10 4.477 10 10 0 .455-.034.903-.093 1.342l-1.618-3.237h-.517A8 8 0 0 0 4 12a7.997 7.997 0 0 0 7.756 7.993L11 21.5v.45c-5.053-.503-9-4.765-9-9.95C2 6.477 6.477 2 12 2z" />
        <path d="M13 8.174c.332.117.637.289.903.508l.925-.924 1.414 1.414-1.29 1.29c.03.175.048.354.048.538h1.263l-1.003 2H15c0 .183-.017.363-.049.537l.026.026-.944 1.884-.13-.13c-.266.22-.571.39-.903.508V17h-2v-1.175a2.991 2.991 0 0 1-.904-.508l-.924.925-1.414-1.414 1.29-1.29A3.018 3.018 0 0 1 9 13H7v-2h2c0-.184.016-.363.048-.538l-1.29-1.29 1.414-1.414.924.924c.266-.22.572-.39.904-.508V7h2zM12 10a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1z" />
      </g>
    </g>
  </Icon>
);
export { SvgNoAllergiesChecked as NoAllergiesChecked };
